<script setup lang="ts">
import { mdiClockOutline } from '@quasar/extras/mdi-v7';
</script>

<template>
  <q-chip
    :dense="!$q.screen.gt.sm"
    rounded
    :icon="mdiClockOutline"
  >
    <span class="tabular-nums">
      <slot />
    </span>
  </q-chip>
</template>
